/**
 * article-progress.js — Reading-Progress + TOC + Copy-Link + Mid-Newsletter
 * Sprint 008 Premium Article Page
 *
 * Funktionen:
 * 1. Sticky Reading-Progress-Bar oben am Viewport (Gradient, requestAnimationFrame).
 * 2. Auto-TOC: scannt H2/H3 im Article-Body → baut Sidebar-Navigation mit Scroll-Spy.
 * 3. Copy-Link-Button: kopiert article.url in Clipboard + Toast-Feedback.
 * 4. Mid-Article Newsletter: fügt CTA-Block bei ~50% Body-Höhe ein (zwischen Paragraphs).
 */
(function () {
  const articleBody = document.querySelector('[data-article-body]');
  const progressBar = document.querySelector('[data-article-progress-bar]');
  const tocSidebar = document.querySelector('[data-article-toc-sidebar]');
  const tocNav = document.querySelector('[data-article-toc]');

  if (!articleBody) return;

  /* ────────────────────────────────────────────────────────────────
     1. Reading Progress Bar
     ──────────────────────────────────────────────────────────────── */
  if (progressBar) {
    let ticking = false;
    const updateProgress = () => {
      const rect = articleBody.getBoundingClientRect();
      const bodyHeight = rect.height;
      const viewportHeight = window.innerHeight;
      const scrolled = -rect.top;
      const maxScroll = Math.max(0, bodyHeight - viewportHeight);
      let progress = 0;
      if (maxScroll > 0) {
        progress = Math.min(100, Math.max(0, (scrolled / maxScroll) * 100));
      } else if (scrolled >= 0) {
        progress = 100;
      }
      progressBar.style.width = progress + '%';
      ticking = false;
    };
    const onScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(updateProgress);
        ticking = true;
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    updateProgress();
  }

  /* ────────────────────────────────────────────────────────────────
     2. Auto-Generate Table of Contents
     ──────────────────────────────────────────────────────────────── */
  const headings = articleBody.querySelectorAll('h2, h3');
  /* Nur TOC wenn mindestens 2 H2s vorhanden (sonst Overhead unnötig) */
  const h2Count = articleBody.querySelectorAll('h2').length;
  if (tocSidebar && tocNav && h2Count >= 2) {
    tocSidebar.removeAttribute('hidden');

    headings.forEach((heading, index) => {
      /* ID erzeugen wenn nicht vorhanden, aus Heading-Text */
      if (!heading.id) {
        const slug = heading.textContent
          .toLowerCase()
          .replace(/[äöüß]/g, (c) => ({ ä: 'ae', ö: 'oe', ü: 'ue', ß: 'ss' }[c]))
          .replace(/[^a-z0-9]+/g, '-')
          .replace(/^-|-$/g, '');
        heading.id = slug || `heading-${index}`;
      }

      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent;
      link.className =
        'article__toc-link article__toc-link--' + heading.tagName.toLowerCase();
      link.dataset.tocTarget = heading.id;
      tocNav.appendChild(link);
    });

    /* Scroll-Spy: highlight aktives TOC-Item basierend auf Scroll-Position */
    const tocLinks = tocNav.querySelectorAll('.article__toc-link');
    const setActive = () => {
      let activeId = null;
      const offset = 120; /* px vom top als "trigger-line" */
      headings.forEach((h) => {
        if (h.getBoundingClientRect().top < offset) {
          activeId = h.id;
        }
      });
      tocLinks.forEach((link) => {
        if (link.dataset.tocTarget === activeId) {
          link.classList.add('article__toc-link--active');
        } else {
          link.classList.remove('article__toc-link--active');
        }
      });
    };
    window.addEventListener('scroll', setActive, { passive: true });
    setActive();
  }

  /* ────────────────────────────────────────────────────────────────
     3. Copy-Link Buttons (Footer + Sticky-Sidebar)
     ──────────────────────────────────────────────────────────────── */
  const setupCopyBtn = (btn) => {
    if (!btn || !navigator.clipboard) return;
    btn.addEventListener('click', async (e) => {
      e.preventDefault();
      try {
        await navigator.clipboard.writeText(window.location.href);
        const originalTitle = btn.getAttribute('title') || 'Link kopieren';
        const originalAria = btn.getAttribute('aria-label');
        btn.setAttribute('title', 'Kopiert! ✓');
        btn.setAttribute('aria-label', 'Link kopiert');
        btn.style.backgroundColor = 'var(--color-success-alt, #16a34a)';
        btn.style.color = '#fff';
        btn.style.borderColor = 'var(--color-success-alt, #16a34a)';
        setTimeout(() => {
          btn.setAttribute('title', originalTitle);
          if (originalAria) btn.setAttribute('aria-label', originalAria);
          btn.style.backgroundColor = '';
          btn.style.color = '';
          btn.style.borderColor = '';
        }, 1800);
      } catch (err) {
        console.error('[article-progress] clipboard failed:', err);
      }
    });
  };
  setupCopyBtn(document.querySelector('[data-article-share-copy]'));
  setupCopyBtn(document.querySelector('[data-article-share-copy-sticky]'));
})();
